import { render } from "./DiplomaBuddy.vue?vue&type=template&id=67dd0181&scoped=true"
import script from "./DiplomaBuddy.vue?vue&type=script&lang=js"
export * from "./DiplomaBuddy.vue?vue&type=script&lang=js"

import "./DiplomaBuddy.vue?vue&type=style&index=0&id=67dd0181&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67dd0181"]])

export default __exports__